import { useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { PageTitle } from '@gplibraries/react/components';
import { LoadingEllipsis } from '@gplibraries/react/components';
import { CacheLookupPolicy, InteractionStatus } from '@azure/msal-browser';

export default function LogoutPage() {

  const { instance, inProgress, accounts } = useMsal();
  const logoutInProgress = useRef(false);

  useEffect(() => {

    // Use a ref here to handle react strict mode quirks
    if (logoutInProgress.current) return;
    if (inProgress !== InteractionStatus.None || !accounts.length) return;

    const checkAndLogout = async () => {

      const logoutRequest = {
        postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}/logout`,
        account: instance.getActiveAccount(),
      }

      try {
        logoutInProgress.current = true;
        await instance.acquireTokenSilent({
          account: accounts[0],
          // Force new network request so we can actually check the server
          cacheLookupPolicy: CacheLookupPolicy.Skip,
        });

        // if previous call succeeded, proceed with logout
        await instance.logoutRedirect(logoutRequest);
      } catch (e) {

        // session is gone on server, but msal cache wasn't refreshed.
        if (e.errorCode === "login_required") {
          // clean up stale cache
          accounts.forEach(async account => {
            await instance.clearCache({ account })
          })
        } else {
          // If other interaction errors occurred, may still have a valid session, just needs prompt
          await instance.logoutRedirect(logoutRequest);
        }

      } finally {
        logoutInProgress.current = false
      }
    };

    checkAndLogout();

  }, [inProgress, instance, accounts, logoutInProgress]);

  return (
    <>
      <PageTitle>Logout</PageTitle>

      {(accounts.length || logoutInProgress.current === true) &&
        <div>Please wait while we log you out<LoadingEllipsis/></div>
      }

      {(!accounts.length && logoutInProgress.current === false) &&
        <div>You have been successfully logged out.</div>
      }

    </>
  )
}